import React from "react";
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import './style.scss';
import { convertToHex } from "../../../../../../helpers/renderers";

const Version = ({ version = '', currentVersion = false, selected = false, onChange }) => {

    const hChangeVersion = () => {
        if (!currentVersion) {
            onChange(version)
        }
    }

    return (
        <div className="version-container" style={{ backgroundColor: selected ? '#353F9433' : 'transparent', cursor: currentVersion ? "default" : 'pointer' }} onClick={hChangeVersion}>
            <p style={{ color: currentVersion ? '#CACED1' : '#111827' }}>{convertToHex(version)}</p>
            {currentVersion && <p style={{ fontWeight: '400', color: '#CACED1' }}>Current Version</p>}
            {selected && <CheckRoundedIcon style={{ color: '#353F94' }} />}
        </div>
    )
};

export default Version;